<template>
  <div class="flex flex-col h-full overflow-hidden">
    <!-- Progress Indicator -->
    <report-progress :showProgress="isLoading" />

    <!-- Table Container with Sticky Header -->
    <div class="flex-1 overflow-hidden">
      <div class="h-full flex flex-col">
        <!-- Single Table with Sticky Header -->
        <div class="flex-1 overflow-auto">
          <table class="w-full table-auto text-sm">
            <thead class="sticky top-0 z-10">
              <tr>
                <th
                  class="!bg-primary-900 text-white set-border text-center font-weight-medium rounded-s-lg px-2 py-2"
                >
                  {{ $t("reports.status_detail_report.head_ID") }}
                </th>
                <th
                  class="!bg-primary-900 text-white set-border text-center font-weight-medium px-2 py-2"
                >
                  {{ $t("reports.status_detail_report.head_Name") }}
                </th>
                <th
                  class="!bg-primary-900 text-white set-border text-center font-weight-medium px-2 py-2"
                >
                  {{ $t("reports.status_detail_report.head_Status") }}
                </th>
                <th
                  class="!bg-primary-900 text-white set-border text-center font-weight-medium px-2 py-2"
                >
                  {{ $t("reports.status_detail_report.head_BeginTime") }}
                </th>
                <th
                  class="!bg-primary-900 text-white set-border text-center font-weight-medium px-2 py-2"
                >
                  {{ $t("reports.status_detail_report.head_EndTime") }}
                </th>
                <th
                  class="!bg-primary-900 text-white set-border text-center font-weight-medium rounded-e-lg px-2 py-2"
                >
                  {{ $t("reports.status_detail_report.head_Duration") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(record, index) in reportData"
                :key="record.uname"
                :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
              >
                <td
                  class="text-center text-grey-darken-1 px-2 py-2 border-b border-gray-200"
                >
                  {{ formatNumber(record.uname) }}
                </td>
                <td
                  class="text-center text-grey-darken-1 px-2 py-2 border-b border-gray-200"
                >
                  {{ record.fullname }}
                </td>
                <td
                  class="text-center text-grey-darken-1 px-2 py-2 border-b border-gray-200"
                >
                  <span
                    :class="`${
                      setStatus(record.status).class
                    } w-fit py-1 px-2 rounded-md `"
                  >
                    <Badge :class="setStatus(record.status).badgeClass" />
                    {{ setStatus(record.status).status }}
                  </span>
                </td>
                <td
                  class="text-center text-grey-darken-1 px-2 py-2 border-b border-gray-200"
                >
                  {{ formatDate(record.begin) }}
                </td>
                <td
                  class="text-center text-grey-darken-1 px-2 py-2 border-b border-gray-200"
                >
                  {{ record.end !== "-" ? formatDate(record.end) : record.end }}
                </td>
                <td
                  class="text-center text-grey-darken-1 px-2 py-2 border-b border-gray-200"
                >
                  {{
                    record.duration !== "-"
                      ? formatDuration(record.duration)
                      : record.duration
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReportProgress from "../../components/ReportProgress.vue";
import { formatNumber, formatArabicDate, formatDuration, setStatus } from "../../utils";
import Badge from "primevue/badge";

export default {
  name: "agent-status-details-report",
  components: {
    ReportProgress,
    Badge,
  },
  props: {
    selectedFilters: {
      type: Object,
      default: () => ({}),
    },
    skills: {
      type: Array,
      default: () => [],
    },
    reportData: {
      type: Array,
      default: () => [],
    },
    totalCount: {
      type: Number,
      default: 0,
    },
    showCount: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    currentLocal() {
      return this.$i18n.locale;
    },
  },
  methods: {
    formatDuration(duration) {
      const lang = this.$i18n.locale;
      return formatDuration(duration, lang);
    },
    formatNumber(num) {
      const lang = this.$i18n.locale;
      return formatNumber(num, lang);
    },
    formatDate(date) {
      const lang = this.$i18n.locale;
      return formatArabicDate(date, lang);
    },
    setStatus(status) {
      return setStatus(status);
    },
  },
};
</script>

<style scoped>
.set-border {
  border: 2px solid #d7eaf3;
}
</style>
